/* ZEPHIR - Comportamientos de la ficha de producto.
 *   1) La barra fija solo aparece cuando el boton principal ya paso el borde.
 *   2) Miga de pan dentro de la columna (no como banda propia).
 *   3) Orden: miga, NOMBRE, marca, precio, color, talla.
 *   4) Al bajar se esconde el menu; al subir reaparece.
 *   5) Miniatura de la barra en su proporcion, no cuadrada.
 *   6) Corazon junto al titulo.
 *   7) Zoom: se apaga el panel de Drift (lupa al pasar el cursor) y el toque o
 *      clic en una foto abre el visor a pantalla completa.
 *   8) "Color: NOMBRE" encima de las bolitas, y fuera el globo al pasar el
 *      cursor: el nombre se lee al elegir, no al apuntar.
 *   9) Barra fija: un grupo por opcion (tallas y color aparte) en vez del
 *      desplegable del tema, que lista TODAS las combinaciones.
 *
 * La ventana de "Politica de envios" y "Cambios y devoluciones" esta en
 * assets/zephir-modal.js.
 *
 * NO SE USA IntersectionObserver: se probo y NO DISPARA NUNCA aqui (cero
 * llamadas al crearlo y cero tras desplazar 1500px con el elemento fuera de
 * vista; se verifico que era el mismo nodo). Se mide con
 * getBoundingClientRect en el scroll, recalculando el elemento cada vez para
 * aguantar que el tema rehaga el formulario al cambiar de variante.
 *
 * TAMPOCO se usa el disparador del tema: no responde a scroll programatico y la
 * clase que conmuta no es la que aparenta (barra visible CON t4s-op-0).
 *
 * ZOOM: el panel que molestaba lo genera DRIFT (window.Drift), no PhotoSwipe.
 * PhotoSwipe SI esta cargado y el tema ya trae un boton .t4s-pr__pswp-btn que
 * abre un visor completo con contador y miniaturas. Ese boton es UNO SOLO y
 * global, asi que abre siempre en la primera foto (ver zoom(): saltar a la
 * tocada se probo y rompia el render).
 *
 * MOVIL: las reglas de opacidad de la barra van dentro de @media(min-width) a
 * proposito. Estaban fuera y, como la clase que la muestra solo se pone en
 * escritorio, la barra quedaba en opacity:0 PARA SIEMPRE en movil y se perdia
 * la barra de compra propia del tema (sticky_layout_mb--minimal).
 */
(function () {
  'use strict';

  var MIN_ANCHO = 768;
  var SEL_BAR  = '.t4s-sticky-atc';
  var SEL_ATC  = '.t4s-product-form__submit';
  var SEL_HEAD = '.t4s-section-header';
  var SEL_BRC  = '.t4s-pr_breadcrumbs';
  var SEL_INFO = '.t4s-product__info-container';
  var SEL_WL   = '.t4s-product-form__btn.t4s-pr-wishlist';
  var SEL_OP   = SEL_INFO + ' .t4s-swatch__option';
  var CURVA    = 'cubic-bezier(.16,1,.3,1)';
  var I = SEL_INFO + ' ';
  var T = I + '[class*=zephir_title] ';

  var css = document.createElement('style');
  css.textContent =
    /* El corazon y la miga se estilan en TODOS los anchos: los movimientos del
       DOM tambien ocurren en movil y sin esto la etiqueta del corazon se
       destapaba y se apilaba en vertical. */
    I + '[class*=zephir_title]{display:flex!important;align-items:flex-start!important;justify-content:space-between!important;gap:16px;}' +
    T + '.t4s-pr-wishlist{position:relative;flex:0 0 auto;display:inline-flex!important;align-items:center;justify-content:center;' +
      'min-width:0!important;border:0!important;background:none!important;margin:0!important;padding:0!important;}' +
    T + '.t4s-pr-wishlist svg{width:21px!important;height:21px!important;}' +
    /* Oculta VISUALMENTE, no display:none: el boton conserva su nombre accesible. */
    T + '.t4s-pr-wishlist .t4s-text-pr{position:absolute!important;width:1px!important;height:1px!important;' +
      'padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;' +
      'white-space:nowrap!important;border:0!important;}' +
    I + '> ' + SEL_BRC + '{padding:0!important;margin:0 0 10px!important;background:none!important;border:0!important;}' +
    I + '> ' + SEL_BRC + ' *{font-size:10px!important;letter-spacing:.66px!important;text-transform:uppercase!important;}' +
    /* (7) Fuera el panel de la lupa; el toque abre el visor. */
    '.t4s-product__zoom-wrapper,.drift-zoom-pane{display:none!important;}' +
    '[data-main-slide]{cursor:zoom-in;}' +
    /* (8) Renglon "Color: NOMBRE" encima de las bolitas. */
    I + '.zph-cl{margin:0 0 8px;font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#8a8a8a;}' +
    I + '.zph-cl b{font-weight:400;color:#161616;}' +
    '@media (min-width:' + MIN_ANCHO + 'px){' +
      /* (9) Fuera la lista combinada del tema; entran los grupos por opcion. */
      SEL_BAR + ' .t4s-sticky-atc__v-title .t4s-dropdown{display:none!important;}' +
      SEL_BAR + ' .zph-sb{display:flex;align-items:center;gap:18px;}' +
      SEL_BAR + ' .zph-sb__lista{display:flex;align-items:center;gap:6px;overflow-x:auto;scrollbar-width:none;}' +
      SEL_BAR + ' .zph-sb__lista::-webkit-scrollbar{display:none;}' +
      SEL_BAR + ' .zph-sb__g--color .zph-sb__lista{max-width:340px;}' +
      SEL_BAR + ' .zph-sb__i{flex:0 0 auto;height:24px;min-width:34px;padding:0 7px;' +
        'border:1px solid rgba(0,0,0,.16);background:#fff;color:#161616;' +
        'font-size:10.5px;letter-spacing:.06em;line-height:1;cursor:pointer;}' +
      SEL_BAR + ' .zph-sb__i.is-on{background:#161616;border-color:#161616;color:#fff;}' +
      SEL_BAR + ' .zph-sb__i.is-off{color:rgba(0,0,0,.34);background-image:linear-gradient(to top right,' +
        'transparent calc(50% - .6px),rgba(0,0,0,.3) 50%,transparent calc(50% + .6px));}' +
      SEL_BAR + ' .zph-sb__c{flex:0 0 auto;width:20px;height:20px;padding:0;border-radius:50%;' +
        'border:1px solid rgba(0,0,0,.16);cursor:pointer;}' +
      SEL_BAR + ' .zph-sb__c.is-on{border-color:transparent;outline:1px solid #161616;outline-offset:2px;}' +
      SEL_BAR + ' .zph-sb__c.is-off{opacity:.4;}' +
      SEL_BAR + '{opacity:0!important;pointer-events:none!important;transform:translateY(-10px);' +
        'transition:opacity .5s ' + CURVA + ',transform .5s ' + CURVA + '!important;will-change:opacity,transform;}' +
      SEL_BAR + '.zph-bar-on{opacity:1!important;pointer-events:auto!important;transform:translateY(0);}' +
      SEL_BAR + ' .t4s-sticky-atc__img{width:auto!important;border-radius:0!important;overflow:hidden;}' +
      SEL_BAR + ' .t4s-sticky-atc__img img{width:auto!important;height:100%!important;border-radius:0!important;object-fit:contain!important;}' +
      SEL_HEAD + '{transition:transform .5s ' + CURVA + '!important;will-change:transform;}' +
      T + '.t4s-pr-wishlist{width:24px!important;height:26px!important;}' +
      I + '.t4s-product-form__quantity,' + I + '.t4s-quantity-wrapper{display:none!important;}' +
      I + SEL_ATC + '{width:100%!important;flex:1 1 100%!important;height:52px!important;' +
        'font-size:11px!important;font-weight:400!important;letter-spacing:1px!important;}' +
    '}' +
    /* En movil el corazon necesita area de toque de 44px (guia de accesibilidad). */
    '@media (max-width:' + (MIN_ANCHO - 1) + 'px){' +
      T + '.t4s-pr-wishlist{width:44px!important;height:44px!important;margin:-9px -10px 0 0!important;}' +
    '}';
  document.head.appendChild(css);

  var bar = null, ultimoY = 0, pedido = false;

  function alturaHeader() {
    var h = document.querySelector(SEL_HEAD);
    return h ? Math.round(h.getBoundingClientRect().height) : 48;
  }

  function actualizar() {
    pedido = false;
    if (!bar) return;
    var ancho = window.innerWidth >= MIN_ANCHO;
    var y = window.scrollY;

    var atc = document.querySelector(SEL_ATC);
    var fuera = false;
    if (atc) fuera = atc.getBoundingClientRect().bottom <= alturaHeader();
    bar.classList.toggle('zph-bar-on', ancho && fuera);

    /* Umbral de 10px: el script de scroll suave del tema emite muchos eventos
     * pequenos y de signo alterno mientras anima, y sin umbral parpadea. */
    var d = y - ultimoY;
    if (Math.abs(d) >= 10) {
      ultimoY = y;
      if (y < 140) document.body.classList.remove('zph-nav-off');
      else document.body.classList.toggle('zph-nav-off', d > 0 && ancho);
    }
  }

  function enScroll() {
    if (pedido) return;
    pedido = true;
    window.requestAnimationFrame(actualizar);
  }

  /* (7) Toque o clic en la foto -> visor a pantalla completa.
   *
   * Se dispara el boton del tema en vez de instanciar PhotoSwipe a mano: asi se
   * reusa su configuracion (contador, miniaturas, pantalla completa) y no hay
   * dos visores compitiendo.
   *
   * POR QUE pointerdown/pointerup EN CAPTURA Y NO 'click':
   *   Con 'click' en burbuja abria unas veces y otras no, en el mismo producto.
   *   El carrusel del tema gestiona el arrastre desde mousedown y corta el
   *   evento antes de llegar a document, asi que el clic real se perdia (el
   *   sintetico si pasaba, de ahi que pareciera funcionar). En captura el
   *   oyente corre antes que nadie y ya no depende de esa carrera.
   *   De paso resuelve el movil: se compara el desplazamiento entre pointerdown
   *   y pointerup, asi un TOQUE abre el visor y un ARRASTRE pasa de foto sin
   *   abrir nada. Umbral de 8px, el temblor normal del dedo.
   *
   * NO SE SALTA A LA FOTO TOCADA. Se probo pulsando su .pswp_thumb_item
   * (PhotoSwipe v4 no expone la instancia: en window solo hay PhotoSwipe y
   * PhotoSwipeUI_Default). El contador si cambiaba a "3 / 3", pero la foto
   * mostrada quedaba en 0x0 -> pantalla en negro, mientras sus vecinas median
   * 412x577. Vale mas abrir siempre en la primera y que el usuario navegue
   * dentro que abrir donde toco y ver negro.
   *
   * El boton se busca DENTRO del oyente, no al registrarlo: el JS del tema lo
   * crea mas tarde que el formulario, y buscandolo antes unas veces estaba y
   * otras no; cuando faltaba se abandonaba sin oyente y la foto quedaba muerta
   * para siempre, porque listo() ya habia devuelto true y no se reintenta. */
  function zoom() {
    var row = document.querySelector('.t4s-row__product');
    if (row) row.classList.remove('is-zoom-enabled', 'is--zoom_tp_external', 'is-zoom-type__external');

    var x0 = 0, y0 = 0, id0 = null;
    document.addEventListener('pointerdown', function (ev) {
      id0 = ev.pointerId; x0 = ev.clientX; y0 = ev.clientY;
    }, true);
    document.addEventListener('pointerup', function (ev) {
      if (ev.pointerId !== id0) return;
      if (Math.abs(ev.clientX - x0) > 8 || Math.abs(ev.clientY - y0) > 8) return;  // arrastre
      if (!ev.target.closest) return;
      if (!ev.target.closest('[data-main-slide]')) return;
      if (ev.target.closest('a,button,[data-action]')) return;   // no robar clics de enlaces
      if (document.querySelector('.pswp--open')) return;         // ya abierto
      var btn = document.querySelector('.t4s-pr__pswp-btn');
      if (btn) btn.click();
    }, true);
  }

  /* (8) "Color: NOMBRE" encima de las bolitas.
   *
   * El nombre sale de data-value del item que lleva is--selected. El globo del
   * tema se apaga quitando title + data-tooltip + la clase t4s-tooltip-actived,
   * que son las tres cosas con las que lo pinta; el title se pasa antes a
   * aria-label para no perder el nombre accesible.
   *
   * Se ESCRIBE SOLO SI CAMBIA. Escribir textContent siempre reemplaza el nodo
   * de texto, y eso dispara el observador de mas abajo, que volveria a llamar
   * aqui: bucle infinito cada 60 ms. */
  function etiquetaColor() {
    var op = document.querySelector(SEL_OP + '.is-t4s-style__color');
    if (!op) return;
    var lista = op.querySelector('.t4s-swatch__list');
    if (!lista) return;

    var et = op.querySelector('.zph-cl');
    if (!et) {
      et = document.createElement('div');
      et.className = 'zph-cl';
      et.innerHTML = 'Color: <b></b>';
      op.insertBefore(et, lista);
    }

    var items = [].slice.call(op.querySelectorAll('.t4s-swatch__item'));
    var sel = null;
    items.forEach(function (it) {
      var n = it.getAttribute('title') || it.getAttribute('data-value') || '';
      if (n && !it.getAttribute('aria-label')) it.setAttribute('aria-label', n);
      it.removeAttribute('title');
      it.removeAttribute('data-tooltip');
      /* 2026-10-06: SOLO SI LA TIENE. classList.remove reescribe el atributo
       * class aunque la clase no este, y eso es un cambio para el observador de
       * vigilar(): volvia a llamar aqui cada 60 ms, sin fin (340 cambios en 5 s
       * con la ficha quieta, 3,7 s de CPU en Lighthouse y la foto principal
       * esperando 6 s para pintarse). removeAttribute de algo que no existe no
       * genera cambio, por eso esas dos lineas no necesitan guarda. */
      if (it.classList.contains('t4s-tooltip-actived')) it.classList.remove('t4s-tooltip-actived');
      if (it.classList.contains('is--selected')) sel = it;
    });

    var b = et.querySelector('b');
    var txt = sel ? (sel.getAttribute('data-value') || '') : '';
    if (b.textContent !== txt) b.textContent = txt;
  }

  /* (9) En la barra fija, un grupo por opcion en vez de la lista combinada.
   *
   * El desplegable del tema (data-sticky-select) imprime UNA LINEA POR VARIANTE
   * con el titulo completo, "L / AZUL REY": con 4 tallas y una docena de
   * colores son mas de 40 lineas para elegir un color. Aqui se pinta un grupo
   * por opcion, las tallas como cajas y el color como bolitas.
   *
   * CADA BOTON HACE click() SOBRE SU ITEM DEL FORMULARIO PRINCIPAL. No se toca
   * la variante ni la URL: de eso sigue encargandose el tema, que ya actualiza
   * precio, foto y boton. Asi no hay dos estados que puedan discrepar. Se
   * verifico que el click programatico sobre un swatch cambia la variante.
   *
   * La firma (cuantos items tiene cada opcion) sirve para rehacer los grupos si
   * el tema reconstruye el formulario, y para no rehacerlos si no hizo falta. */
  function barraOpciones() {
    var b = document.querySelector(SEL_BAR);
    if (!b) return;
    var vt = b.querySelector('.t4s-sticky-atc__v-title');
    if (!vt) return;

    var ops = [].slice.call(document.querySelectorAll(SEL_OP));
    if (!ops.length) return;

    var firma = ops.map(function (op) { return op.querySelectorAll('.t4s-swatch__item').length; }).join('-');
    var cont = vt.querySelector('.zph-sb');
    if (cont && cont.getAttribute('data-firma') !== firma) { cont.remove(); cont = null; }

    if (!cont) {
      cont = document.createElement('div');
      cont.className = 'zph-sb';
      cont.setAttribute('data-firma', firma);

      ops.forEach(function (op, gi) {
        var esColor = op.classList.contains('is-t4s-style__color');
        var g = document.createElement('div');
        g.className = 'zph-sb__g' + (esColor ? ' zph-sb__g--color' : '');
        var lista = document.createElement('div');
        lista.className = 'zph-sb__lista';

        [].slice.call(op.querySelectorAll('.t4s-swatch__item')).forEach(function (it, i) {
          var v = it.getAttribute('data-value') || '';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('data-zph-g', gi);
          btn.setAttribute('data-zph-i', i);
          if (esColor) {
            btn.className = 'zph-sb__c';
            // La bolita la pinta assets/colors.css por la clase bg_color_x.
            var bg = (String(it.className).match(/bg_color_[a-z0-9-]+/) || [])[0];
            if (bg) btn.classList.add(bg);
            btn.setAttribute('aria-label', v);   // sin title: nada de globos
          } else {
            btn.className = 'zph-sb__i';
            btn.textContent = v;
          }
          lista.appendChild(btn);
        });

        g.appendChild(lista);
        cont.appendChild(g);
      });

      cont.addEventListener('click', function (ev) {
        var btn = ev.target.closest ? ev.target.closest('button[data-zph-i]') : null;
        if (!btn) return;
        var op = document.querySelectorAll(SEL_OP)[+btn.getAttribute('data-zph-g')];
        if (!op) return;
        var it = op.querySelectorAll('.t4s-swatch__item')[+btn.getAttribute('data-zph-i')];
        if (it) it.click();
      });

      vt.appendChild(cont);
    }

    // El estado visible se COPIA del formulario, no se decide aqui.
    ops.forEach(function (op, gi) {
      var its = op.querySelectorAll('.t4s-swatch__item');
      for (var i = 0; i < its.length; i++) {
        var btn = cont.querySelector('[data-zph-g="' + gi + '"][data-zph-i="' + i + '"]');
        if (!btn) continue;
        btn.classList.toggle('is-on', its[i].classList.contains('is--selected'));
        btn.classList.toggle('is-off', its[i].classList.contains('is--soldout'));
      }
    });
  }

  /* El tema vuelve a marcar los swatches (y a veces rehace el formulario) en
   * cada cambio de variante, asi que (8) y (9) se re-aplican. Solo se escucha
   * 'class' y childList dentro de la columna; los cambios propios que se hacen
   * en la barra fija quedan fuera de este arbol y no realimentan. */
  function vigilar() {
    var info = document.querySelector(SEL_INFO);
    if (!info || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { etiquetaColor(); barraOpciones(); }, 60);
    }).observe(info, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  function listo() {
    bar = document.querySelector(SEL_BAR);
    var atc = document.querySelector(SEL_ATC);
    if (!bar || !atc) return false;
    var info = document.querySelector(SEL_INFO);

    /* (2) Se mueve el nodo entero de la banda: asi viaja tambien su JSON-LD de
     * BreadcrumbList y no se duplica nada. */
    var brc = document.querySelector(SEL_BRC);
    if (brc && info && brc.parentElement !== info) info.insertBefore(brc, info.firstChild);

    if (info) {
      var vendor = info.querySelector('[class*=zephir_vendor]');
      var titulo = info.querySelector('[class*=zephir_title]');
      if (vendor && titulo && (titulo.compareDocumentPosition(vendor) & Node.DOCUMENT_POSITION_PRECEDING)) {
        info.insertBefore(titulo, vendor);
      }
      var wl = info.querySelector(SEL_WL);
      if (wl && titulo && wl.parentElement !== titulo) titulo.appendChild(wl);
    }

    zoom();
    etiquetaColor();
    barraOpciones();
    vigilar();
    ultimoY = window.scrollY;
    window.addEventListener('scroll', enScroll, { passive: true });
    window.addEventListener('resize', enScroll);
    actualizar();
    return true;
  }

  var n = 0;
  function arrancar() {
    var ok = false;
    try { ok = listo(); } catch (e) {}
    if (ok || ++n > 30) return;
    setTimeout(arrancar, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
